import React, { useEffect, useState } from "react";
import Sidebar from "../components/Sidebar";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import {
  adminActions,
  createOfficeAdmin,
  deleteOfficeAdmin,
  editOfficeAdmin,
  fetchOfficeAdmins,
  signOut,
} from "../store/adminSlice";
import HeaderScaff from "../components/HeaderScaff";
import escapeHtml from "../functions/Validator";
import { useNavigate } from "react-router-dom";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { useMediaQuery } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import $ from "jquery";
$.DataTable = require("datatables.net");

function ManageOfficeAdmins() {
  const isNonMobile = useMediaQuery("(min-width: 768px)");
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const dispatch = useDispatch();
  const [needed, setNeeded] = useState(false);
  const _id = useSelector((state) => state.admin._id);
  const [data, setData] = useState({
    fullName: "",
    email: "",
    password: "",
    adminID: _id,
  });

  const officeAdmins = useSelector((state) => state.admin.officeAdmins);
  const customerSwalAlert = useSelector(
    (state) => state.admin.customerSwalAlert
  );

  const [edit, setEdit] = useState(false);
  const [editID, setEditID] = useState("");
  const [forEdit, setForEdit] = useState({
    fullName: "",
    email: "",
    password: "",
    adminID: _id,
    _id: "",
  });
  const navigate = useNavigate();
  const subscribed = useSelector((state) => state.admin.subscribed);
  const statesignOut = useSelector((state) => state.admin.signOut);
  useEffect(() => {
    if (!_id) {
      navigate("/signin");
    } else if (!subscribed) {
      navigate("/signin");
    }
    if (!isNonMobile) {
      setSidebarOpen(false);
    }
  }, []);
  const handleSubmit = (e) => {
    e.preventDefault();

    if (data.fullName === "" || data.email === "" || data.password === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        confirmButtonColor: "#60c088",
        text: "Kindly fill all the inputs.!",
      });
      return;
    }
    dispatch(createOfficeAdmin(data)).then(() => {
      setData({
        fullName: "",
        email: "",
        password: "",
        adminID: _id,
      });
    });
  };
  useEffect(() => {
    if (statesignOut === "signOut") {
      dispatch(signOut());
    }
  }, [statesignOut]);

  useEffect(() => {
    dispatch(fetchOfficeAdmins({ adminID: _id }));
  }, []);

  // Initialize DataTable only if there's data
  useEffect(() => {
    // Clean up function to ensure DataTable is destroyed when component unmounts
    return () => {
      if ($.fn.DataTable.isDataTable('#table')) {
        $('#table').DataTable().destroy();
      }
    };
  }, []);
  
  useEffect(() => {
    if (officeAdmins && officeAdmins.length > 0) {
      // Ensure any existing DataTable is destroyed first
      if ($.fn.DataTable.isDataTable('#table')) {
        $('#table').DataTable().destroy();
      }
      
      // Small timeout to ensure DOM is ready
      setTimeout(() => {
        // Check if the table still exists in DOM before initializing
        if (document.getElementById('table')) {
          $("#table").DataTable({ 
            pagingType: "simple_numbers", 
            retrieve: true,
            destroy: true // Ensure table can be reinitialized
          });
        }
      }, 50);
    }
  }, [officeAdmins]);

  useEffect(() => {
    if (customerSwalAlert === "emailDuplicated") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        confirmButtonColor: "#60c088",
        text: "Email already registered.!",
      }).then(() => {
        dispatch(adminActions.removeCustomerSwalAlert());
      });
    }
  }, [customerSwalAlert]);

  const deleteItem = (thtItem) => {
    var nn = { thtItem: thtItem, _id: thtItem._id, adminID: _id };
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#60c088",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        // Destroy DataTable before React updates the DOM
        if ($.fn.DataTable.isDataTable('#table')) {
          $('#table').DataTable().destroy();
        }
        
        dispatch(deleteOfficeAdmin(nn));
        
        Swal.fire({
          title: "Deleted!",
          text: "Office admin has been deleted.",
          icon: "success",
          confirmButtonColor: "#60c088",
        });
      }
    });
  };

  const editItem = (thtItem) => {
    setData({
      ...data,
      fullName: thtItem.fullName,
      email: thtItem.email,
      password: "",
      adminID: _id,
    });
    setEditID(thtItem._id);
    setEdit(true);
  };

  const handleUpdate = (e) => {
    e.preventDefault();
    if (data.fullName === "" || data.email === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        confirmButtonColor: "#60c088",
        text: "Kindly fill all the required inputs.!",
      });
      return;
    }
    setForEdit({
      ...forEdit,
      fullName: data.fullName,
      email: data.email,
      password: data.password,
      adminID: _id,
      _id: editID,
    });
  };

  const handleUpdateCancel = () => {
    setEdit(false);
    setData({
      fullName: "",
      email: "",
      password: "",
      adminID: _id,
    });
  };

  useEffect(() => {
    if (forEdit._id) {
      dispatch(editOfficeAdmin(forEdit));
      setData({
        fullName: "",
        email: "",
        password: "",
        adminID: _id,
      });
      setEdit(false);
    }
  }, [forEdit]);

  return (
    <div className="w-full h-full">
      <HeaderScaff />
      <div
        className={`${
          sidebarOpen ? "" : isNonMobile ? "" : "flex-col"
        } 'w-full flex h-auto p-2 sm:p-6'`}
      >
        <div
          className={`${
            sidebarOpen
              ? isNonMobile
                ? "basis-1/5"
                : "flex justify-center w-full"
              : "hidden"
          } "w-full h-full"`}
        >
          <Sidebar
            setSidebarOpen={setSidebarOpen}
            needed={needed}
            isNonMobile={isNonMobile}
          />
        </div>

        <div
          onClick={() => setSidebarOpen(true)}
          className={`${
            sidebarOpen
              ? isNonMobile
                ? "hidden"
                : "hidden"
              : isNonMobile
              ? "flex w-12 mt-4"
              : "flex border-2 border-x-0 bg-gray-100/50 mt-2 -mb-1 w-full items-center justify-center"
          } h-fit`}
        >
          <div
            className={`${
              sidebarOpen
                ? isNonMobile
                  ? ""
                  : ""
                : isNonMobile
                ? ""
                : "hidden"
            } `}
          >
            <IconButton onClick={() => setSidebarOpen(true)}>
              <ArrowForwardIosIcon />
            </IconButton>
          </div>
          <div
            className={`${
              sidebarOpen
                ? isNonMobile
                  ? "hidden"
                  : "hidden"
                : isNonMobile
                ? "hidden"
                : "flex"
            } `}
          >
            <p className="text-gray-500 text-xs py-[2px]">Sidebar</p>
          </div>
        </div>

        <div
          className={`${
            sidebarOpen
              ? isNonMobile
                ? "lg:basis-3/4 w-full flex flex-col"
                : "hidden"
              : "w-full flex flex-col"
          } " "`}
        >
          <p className="text-lg xxl:text-2xl text-slate-400 pb-1 ml-2 mt-4">
            Manage Office Admins
          </p>

          <form
            onSubmit={handleSubmit}
            className="lg:flex lg:flex-row flex-col"
          >
            <div className="lg:basis-1/2 w-full">
              <div className="p-2 flex flex-col w-full ">
                <p className="p-1 font-semibold text-xs xxl:text-xl">
                  Full Name
                </p>
                <input
                  className="bg-gray-200 opacity-50 p-[2px] xxl:p-3 outline-none pl-1"
                  value={data?.fullName}
                  onChange={(e) =>
                    setData({
                      ...data,
                      fullName: escapeHtml(e.target.value),
                    })
                  }
                  type="text"
                  required
                />
                <p className="p-1 font-semibold text-xs xxl:text-xl">Email or Username</p>
                <input
                  className="bg-gray-200 opacity-50 p-[2px] xxl:p-3 outline-none pl-1"
                  autoComplete="off"
                  value={data?.email}
                  onChange={(e) =>
                    setData({ ...data, email: escapeHtml(e.target.value) })
                  }
                  type="email"
                  placeholder="Enter username@[company name]"
                  required
                />
              </div>
            </div>

            <div className="basis-1/2 flex-col flex justify-between">
              <div className="p-2 flex flex-col w-full">
                <p className="p-1 font-semibold text-xs xxl:text-xl">
                  {!edit ? "Password" : "New Password"}
                </p>
                <div className="flex justify-between">
                  <input
                    className="bg-gray-200 opacity-50 p-[2px] xxl:p-3 w-1/2 outline-none pl-1"
                    value={data?.password}
                    onChange={(e) =>
                      setData({ ...data, password: escapeHtml(e.target.value) })
                    }
                    type="text"
                    required={!edit}
                  />
                  <div className="pl-2 w-full">
                    {edit ? (
                      <>
                        <button
                          className="w-24 h-8 mr-3 xxl:w-32 xxl:h-10 text-white cursor-pointer rounded-md bg-lightgreen text-sm xxl:text-lg hover:bg-darkgreen"
                          type="submit"
                          onClick={(e) => handleUpdate(e)}
                        >
                          Update
                        </button>
                        <button
                          className="w-24 h-8 xxl:w-32 xxl:h-10 text-white cursor-pointer rounded-md bg-lightgreen text-sm xxl:text-lg hover:bg-darkgreen"
                          onClick={handleUpdateCancel}
                          type="button"
                        >
                          Cancel
                        </button>
                      </>
                    ) : (
                      <button
                        className="w-24 h-8 xxl:w-32 xxl:h-10 text-white cursor-pointer rounded-md bg-lightgreen text-sm xxl:text-lg hover:bg-darkgreen"
                        type="submit"
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="flex content-between justify-between"></div>
            </div>
          </form>

          <p className="text-lg xxl:text-2xl text-slate-400 pb-1 ml-2">
            Office Admin List
          </p>

          <div className="lg:w-full overflow-x-auto lg:overflow-x-hidden pr-1">
            {officeAdmins && officeAdmins.length > 0 ? (
              <table className="editor_listing_table" id="table">
                <thead className="w-full">
                  <tr className="bg-lightgreen">
                    <th className="whitespace-nowrap text-start px-2 py-1 text-sm xxl:text-base text-white rounded-l-md font-normal border-[1px] border-r-white">
                      Name
                    </th>
                    <th className="text-start px-2 py-1 text-sm xxl:text-base text-white font-normal border-[1px] border-r-white">
                      Email
                    </th>
                    <th className="text-start px-2 py-1 text-sm xxl:text-base text-white font-normal rounded-r-lg">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody className="">
                  {officeAdmins.map((admin) => (
                    <tr key={admin?._id}>
                      <td className="w-3/12 border-[1px] border-gray-300 pl-2 p-1 text-[11px] xxl:text-sm">
                        {admin?.fullName}
                      </td>
                      <td className="w-4/12 border-[1px] border-gray-300 pl-2 p-1 text-[10px] xxl:text-[13px]">
                        {admin?.email}
                      </td>
                      <td className="w-3/12 border-[1px] border-gray-300 p-1">
                        <div className="flex flex-row justify-center space-x-2 xxl:space-x-5 px-4">
                          <div
                            onClick={() => editItem(admin)}
                            className="flex flex-col items-center"
                          >
                            <EditIcon
                              sx={{ width: "17px", height: "17px" }}
                              className="text-lightgreen hover:text-darkgreen cursor-pointer"
                            />
                            <p className="text-[10px] xxl:text-sm">Edit</p>
                          </div>
                          <div
                            onClick={() => deleteItem(admin)}
                            className="flex flex-col items-center"
                          >
                            <DeleteIcon
                              sx={{ width: "17px", height: "17px" }}
                              className="text-lightgreen hover:text-darkgreen cursor-pointer"
                            />
                            <p className="text-[10px] xxl:text-sm">Delete</p>
                          </div>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            ) : (
              <div className="border-[1px] border-gray-200 p-4 rounded-md text-center text-gray-500">
                No office admins found.
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ManageOfficeAdmins;
